<template>
  <div>
    <div class="SelTop">
      <div class="showDate" v-show="showDate">
        <ul>
          <li>
            数据更新时间：每日16:00-17:00为更新高峰，更新截止当日15:30产生的数据，
          </li>
          <li>关帐周更新如有延迟请谅解。</li>
          <li>FTZ数据更新时间：每日18：00左右更新截止前日24：00的FTZ数据</li>
        </ul>
      </div>

      <div class="sel_right" @click="showUpdata()">
        <p>更新时间说明</p>
        <b>!</b>
      </div>
    </div>

    <div style="padding: 0 10px">
      <van-row
        type="flex"
        justify="center"
        style="
          height: 32px;
          line-height: 32px;
          font-weight: 600;
          color: rgb(151, 121, 87);
          background-color: #e2ccb2;
          font-size: 14px;
        "
        class="OneTie OneTieactive"
      >
        <van-col span="2"> </van-col>
        <van-col span="6" style="border-right: 1px solid rgba(0, 0, 0, 0.1)">
          Channel View
        </van-col>
        <van-col span="6" style="border-right: 1px solid rgba(0, 0, 0, 0.1)">
          Inv Value
        </van-col>
        <van-col span="6"> Inv Days </van-col>
        <van-col span="2"> </van-col>
      </van-row>
 

    <div class="box" v-for="(item, i) in tableList" :key="i">
      <van-row
        type="flex"
        justify="center"
        class="OneTie OneTieactive"
        @click.stop="changeImg($event)"
      >
        <van-col span="3">
          <div class="redPlus" style="display: flex; justify-content: center">
            <img src="../../../assets/jpg/icon-1-down.png" alt />
          </div>
        </van-col>

        <van-col span="6">
          <div
            class="tableLeft"
            style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
          >
            <div class="leftFlex">
              <span>{{ item.level1 }}</span>
            </div>
          </div>
        </van-col>

        <van-col span="6">
          <div
            class="tableCenter"
            style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
          >
            <div class="centerFlex">
              <span>{{ item.inv_value | NumFormat }}</span>
            </div>
          </div>
        </van-col>

        <van-col span="6">
          <div class="tableCenter">
            <div class="centerFlex">
              <span>{{ item.inv_days | NumFormat }}</span>
            </div>
          </div>
        </van-col>

        <van-col span="3">
          <div
            class="red"
            style="display: flex; justify-content: center"
            @click.stop="changeBrand($event)"
          >
            <img src="../../../assets/jpg/icon-tag1.png" alt="" />
          </div>
        </van-col>
      </van-row>
      <!-- Brand List1 start  -->
      <div
        v-show="brand1"
        v-for="brandItem in item.level1ByBrandList"
        :key="brandItem.brandCd"
        class="BrandOneTie"
      >
        <van-row
          type="flex"
          justify="center"
          class="BrandThrTie"
          :assgin="brandItem.brandCd"
        >
          <van-col span="2"></van-col>
          <van-col span="6">
            <div
              class="tableLeft"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="leftFlex">
                <span>{{ brandItem.brandCd }}</span>
              </div>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="tableCenter"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="centerFlex">
                <span>{{ brandItem.inv_value | NumFormat }}</span>
              </div>
            </div>
          </van-col>
          <van-col span="6">
            <div class="tableCenter">
              <div class="centerFlex">
                <span>{{ brandItem.inv_days | NumFormat }}</span>
              </div>
            </div>
          </van-col>
          <van-col span="2"></van-col>
        </van-row>
      </div>
      <!-- Brand List1  end  -->

      <div
        v-show="isShow"
        v-for="item1 in item.levelList2"
        :key="item1.level2"
        class="ChannelList1"
      >
        <van-row
          type="flex"
          justify="center"
          class="OneTie TwoTieactive"
          :assgin="item1.level2"
          @click.stop="changeChannel($event), changeChannelTwo($event)"
        >
          <van-col span="3">
            <div
              class="redPlus"
              style="display: flex; justify-content: center"
              v-show="item1.levelList3.length > 0"
            >
              <img src="../../../assets/jpg/icon-2-right.png" alt />
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="tableLeft"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="leftFlex">
                <span>{{ item1.level2 }}</span>
              </div>
            </div>
          </van-col>

          <van-col span="6">
            <div
              class="tableCenter"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="centerFlex">
                <span>{{ item1.inv_value | NumFormat }}</span>
              </div>
            </div>
          </van-col>

          <van-col span="6">
            <div class="tableCenter">
              <div class="centerFlex">
                <span>{{ item1.inv_days | NumFormat }}</span>
              </div>
            </div>
          </van-col>

          <van-col span="3">
            <div
              class="red"
              style="display: flex; justify-content: center"
              @click.stop="changeBrandTwo($event)"
            >
              <img src="../../../assets/jpg/icon-tag1.png" alt="" />
            </div>
          </van-col>
        </van-row>

        <div
          v-show="brand2"
          v-for="brandItem1 in item1.level2ByBrandList"
          :key="brandItem1.brandCd"
          class="BrandTieTie"
        >
          <van-row
            type="flex"
            justify="center"
            class="BrandThrTie"
            :assgin="brandItem1.brandCd"
          >
            <van-col span="2"></van-col>
            <van-col span="6">
              <div
                class="tableLeft"
                style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
              >
                <div class="leftFlex">
                  <span>{{ brandItem1.brandCd }}</span>
                </div>
              </div>
            </van-col>

            <van-col span="6">
              <div
                class="tableCenter"
                style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
              >
                <div class="centerFlex">
                  <span>{{ brandItem1.inv_value | NumFormat }}</span>
                </div>
              </div>
            </van-col>

            <van-col span="6">
              <div class="tableCenter">
                <div class="centerFlex">
                  <span>{{ brandItem1.inv_days | NumFormat }}</span>
                </div>
              </div>
            </van-col>
            <van-col span="2"></van-col>
          </van-row>
        </div>

        <div
          v-show="isShow2"
          v-for="item2 in item1.levelList3"
          :key="item2.level3"
          class="TwoTieAct"
        >
          <van-row
            type="flex"
            justify="center"
            class="TwoTie"
            style="margin-bottom: 2px"
            v-if="item2.level3 != 'Mid'"
            @click.stop="changeChannelThr($event)"
          >
            <van-col span="3">
              <div
                class="redPlus"
                style="display: flex; justify-content: center"
                v-show="item2.levelList4.length > 1"
              >
                <img
                  src="../../../assets/jpg/icon-2-right.png"
                  style="width: 22px; height: 22px"
                  alt
                />
              </div>
            </van-col>
            <van-col span="6">
              <div
                class="tableLeft"
                style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
              >
                <div class="leftFlex">
                  <span>{{
                    item2.level3 == "Mid" ? "Central" : item2.level3
                  }}</span>
                </div>
              </div>
            </van-col>
            <van-col span="6">
              <div
                class="tableCenter"
                style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
              >
                <div class="centerFlex">
                  <span>{{ item2.inv_value | NumFormat }}</span>
                </div>
              </div>
            </van-col>

            <van-col span="6">
              <div class="tableCenter">
                <div class="centerFlex">
                  <span>{{ item2.inv_days | NumFormat }}</span>
                </div>
              </div>
            </van-col>

            <van-col span="3">
              <div
                class="red"
                style="display: flex; justify-content: center"
                @click.stop="changeBrandThr($event)"
              >
                <img src="../../../assets/jpg/icon-tag1.png" alt="" />
              </div>
            </van-col>
          </van-row>

          <div
            class="BrandThrTie"
            v-show="brand3"
            v-for="brandItem2 in item2.level3ByBrandList"
            :key="brandItem2.brandCd"
          >
            <van-row
              type="flex"
              justify="center"
              class="BrandThrTie"
              style="background: rgb(246, 246, 255)"
            >
              <van-col span="2"></van-col>
              <van-col span="6">
                <div class="tableLeft">
                  <div class="leftFlex">
                    <span>{{ brandItem2.brandCd }}</span>
                  </div>
                </div>
              </van-col>

              <van-col span="6">
                <div
                  class="tableCenter"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="centerFlex">
                    <span>{{ brandItem2.inv_value | NumFormat }}</span>
                  </div>
                </div>
              </van-col>

              <van-col span="6">
                <div
                  class="tableCenter"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="centerFlex">
                    <span>{{ brandItem2.inv_days | NumFormat }}</span>
                  </div>
                </div>
              </van-col>
              <van-col span="2"></van-col>
            </van-row>
          </div>
          <!-- Brand List3 end-->

          <div
            class="channelThr"
            v-show="channel3"
            v-for="channel3Item in item2.levelList4"
            :key="channel3Item.level4"
          >
            <van-row
              type="flex"
              justify="center"
              class="channelThr"
              style="
                background: rgb(246, 246, 255);
                height: 50px;
                border-bottom: 2px solid #ccc;
              "
            >
              <van-col span="3"> </van-col>

              <van-col span="6">
                <div
                  class="tableLeft"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="leftFlex">
                    <span>{{ channel3Item.level4 }}</span>
                  </div>
                </div>
              </van-col>

              <van-col span="6">
                <div
                  class="tableCenter"
                  style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                >
                  <div class="centerFlex">
                    <span>{{ channel3Item.inv_value | NumFormat }}</span>
                  </div>
                </div>
              </van-col>

              <van-col span="6">
                <div class="tableCenter">
                  <div class="centerFlex">
                    <span>{{ channel3Item.inv_days | NumFormat }}</span>
                  </div>
                </div>
              </van-col>

              <van-col
                span="3"
                v-if="channel3Item.level4ByBrandList.length >= 1"
              >
                <div
                  class="red"
                  @click.stop="changeBrandFor($event)"
                  style="display: flex; justify-content: center"
                >
                  <img src="../../../assets/jpg/icon-tag1.png" alt="" />
                </div>
              </van-col>
            </van-row>
            <!-- Brand List4 start -->
            <div
              class="BrandForTie"
              v-show="brand4"
              v-for="brandItem3 in channel3Item.level4ByBrandList"
              :key="brandItem3.brandCd"
            >
              <van-row
                type="flex"
                justify="center"
                class="BrandForTie"
                style="background: rgb(246, 246, 255)"
              >
                <van-col span="2"> </van-col>

                <van-col span="6">
                  <div
                    class="tableLeft"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="leftFlex">
                      <span>{{ brandItem3.brandCd }}</span>
                    </div>
                  </div>
                </van-col>
                <van-col span="6">
                  <div
                    class="tableCenter"
                    style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
                  >
                    <div class="centerFlex">
                      <span>{{ brandItem3.inv_value | NumFormat }}</span>
                    </div>
                  </div>
                </van-col>

                <van-col span="6">
                  <div class="tableCenter">
                    <div class="centerFlex">
                      <span>{{ brandItem3.inv_days | NumFormat }}</span>
                    </div>
                  </div>
                </van-col>

                <van-col span="2"> </van-col>
              </van-row>
            </div>
            <!-- Brand List4 end -->
          </div>
        </div>
        <van-row
          type="flex"
          justify="center"
          v-show="isShow2"
          class="TwoTieAct"
          v-if="item1.levelList3Map && item1.levelList3Map.length > 1"
        >
          <van-col span="7">
            <van-row
              v-for="item3 in item1.levelList3Map"
              :key="item3.karegionplatform"
            >
              <div class="list" v-if="item3.karegionplatform != 'Mid'">
                <b>{{
                  item3.karegionplatform == "Mid"
                    ? "Central"
                    : item3.karegionplatform
                }}</b>
                <span>{{ item3.salesValue | NumFormat }}</span>
              </div>
            </van-row>
          </van-col>
          <van-col span="12" :class="item1.level2">
            <Mymap :binId="item1.level2" :areaList="MapList"></Mymap>
          </van-col>
        </van-row>
      </div>
    </div>

  </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";
import "echarts/map/js/china.js";
import Mymap from "@/components/ButSecoend/Public/Map";

export default {
  data() {
    return {
      isShow: true,
      isShow2: false,
      tableList: [],
      MapList: [],
      MapData: [],
      isBtn: true,
      isBtn2: true,
      achVing: sessionStorage.getItem("achVing"),
      showDate: false,
      brand1: false,
      brand2: false,
      brand3: false,
      brand4: false,
      channel3: false,
      type: "",
    };
  },
  methods: {
    changeBrand(e) {
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActiveImg");
      }
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus redPlusActiveImg redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActiveImg");
      } else {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .addClass("redPlusActiveImg");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandOneTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".ChannelList1")
        .css("display", "none");
    },
    changeBrandTwo(e) {
      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActive");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandTieTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".TwoTieAct")
        .css("display", "none");
    },
    changeBrandThr(e) {
      console.log($(e.currentTarget).parent().parent());
      if (
        $(e.currentTarget).parent().parent().find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget)
          .parent()
          .parent()
          .find(".redPlus")
          .removeClass("redPlusActive");
      }
      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }

      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandThrTie")
        .stop()
        .slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".channelThr")
        .css("display", "none");
    },
    changeBrandFor(e) {
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".BrandForTie")
        .stop()
        .slideToggle(500);
      if ($(e.currentTarget).attr("class") == "red redActive") {
        $(e.currentTarget).removeClass("redActive");
      } else {
        $(e.currentTarget).addClass("redActive");
      }
    },
    changeChannel(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      if (
        $(e.currentTarget).find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget).find(".redPlus").removeClass("redPlusActive");
      } else {
        $(e.currentTarget).find(".redPlus").addClass("redPlusActive");
      }
      $(e.currentTarget).nextAll(".TwoTieAct").stop().slideToggle(500);
      $(e.currentTarget).nextAll(".BrandOneTie").css("display", "none");
    },
    changeChannelTwo(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      $(e.currentTarget)
        .parent()
        .parent()
        .nextAll(".TwoTieAct")
        .stop()
        .slideToggle(500);
      $(e.currentTarget).nextAll(".BrandTieTie").css("display", "none");
    },
    changeChannelThr(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      if (
        $(e.currentTarget).find(".redPlus").attr("class") ==
        "redPlus redPlusActive"
      ) {
        $(e.currentTarget).find(".redPlus").removeClass("redPlusActive");
      } else {
        $(e.currentTarget).find(".redPlus").addClass("redPlusActive");
      }
      $(e.currentTarget).nextAll(".channelThr").stop().slideToggle(500);

      $(e.currentTarget).nextAll(".BrandThrTie").css("display", "none");
    },
    showUpdata() {
      this.showDate = !this.showDate;
    },
    getList() {
      this.$addr
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getChannelByList")
        // .get("sellin/getChannelByList")
        // .get("sellinAndsellout/getBuByListSellInAndSellOutInv")
        .get("sellinAndsellout/getChannelByListSellInAndSellOutInv")
        .then((res) => {
          this.achVing = 0;
          this.achVing = parseFloat(sessionStorage.getItem("achVing"));
          this.tableList = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getType() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        .get("sellin/getTargetType")

        .then((res) => {
          this.type = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    changeImg(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red redActive") {
        $(e.currentTarget).find(".red").removeClass("redActive");
      }
      if (
        $(e.currentTarget).find(".redPlus").attr("class") ==
        "redPlus redPlusActiveImg"
      ) {
        $(e.currentTarget).find(".redPlus").removeClass("redPlusActiveImg");
      } else {
        $(e.currentTarget).find(".redPlus").addClass("redPlusActiveImg");
      }
      $(e.currentTarget).nextAll(".ChannelList1").stop().slideToggle(500);
      $(e.currentTarget).nextAll(".BrandOneTie").css("display", "none");
    },
  },
  created() {
    this.getList();
    this.getType();
    sessionStorage.setItem("MapFlag", "");
  },
  components: {
    Mymap,
  },
};
</script>
<style scoped>
.clickInfo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
}
.clickInfo p {
  color: #424242;
  letter-spacing: 0;
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 10px;
}
.showDate {
  padding: 20px;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #191919;
  border: 1px solid black;
  z-index: 999999999999999;
  position: absolute;
  top: 30px;
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 20px;
  width: 90%;
}

.tableCenter .centerFlex span {
  font-family: "微软雅黑" !important;
  font-weight: 600;
  font-size: 12px;
  color: #443b72;
}

.tableCenter {
  /* padding: 12px 5px 13px 22px; */
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  min-height: 45px;
}

ul li {
  margin-bottom: 2px;
  font-size: 10px;
  color: #191919;
  width: 100%;
  height: 20px;
  /* 强制不换行 */
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(157, 157, 157, 0.4);
  line-height: 20px;
}
.SelTop {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.SelTop .sel_right {
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  width: 450px;
  height: 21px;
  background: rgba(152, 152, 152, 0.5);
  box-shadow: inset 0 0 5px 0 #9e9e9e;
  border-radius: 42.5px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.SelTop .sel_right p {
  float: left;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  line-height: 21px;
  color: #f9f9f9;
  padding-left: 13px;
}
.SelTop .sel_right b {
  float: right;
  margin-right: 5px;
  margin-top: 5px;
  text-align: center;
  line-height: 12px;
  font-size: 10px;
  background: #f9f9f9;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.red {
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 100%;
  transform: scaleX(-1);
  box-shadow: 0 0 5px -1px rgba(90, 66, 37, 0.5);
  border-radius: 10px 0px 0px 10px;
  /* height: 89%; */
}
.redActive {
  display: flex;
  align-items: center;
  padding: 0 10px;
  transform: scaleX(-1);
  box-shadow: inset 0 0 5px 0 rgba(59, 59, 59, 0.5);
  border-radius: 10px 0px 0px 10px;
}
.red img {
  width: 17px;
  height: 17px;
}
.redPlus {
  display: flex;
  align-items: center;
  height: 100%;
  /* margin: 0 10px; */
}
.redPlus img {
  width: 30px;
  height: 30px;
}
.redPlusActive > img {
  transform: rotate(90deg);
}
.redPlusActiveImg > img {
  transform: rotate(-90deg);
}
.LittleBut {
  height: 20px;
  width: 20px;
  text-align: center;
  background: rgba(158, 131, 108, 0.3);
  border-radius: 50%;
  line-height: 20px;
}
.notice {
  background: #c7544d !important;
}
.noticeCol {
  background: #f9c6bd !important;
}
.noticeFormat {
  color: #c7544d !important;
}
.helthyFormat {
  color: #84a05f !important;
}
.pinFormat {
  color: #e9c978 !important;
}
.pinCol {
  background: #f3d480 !important;
}
.helthyCol {
  background: #d4e1b4 !important;
}
.helthy {
  background: #84a05f !important;
}
.pin {
  background: #f3d480 !important;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list b {
  text-align: right;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  height: 37px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.list span {
  text-align: left;
  font-family: "微软雅黑" !important;
  height: 37px;
  min-width: 50px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.tableLeft {
  /* padding: 12px 5px 13px 22px; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 45px;

  font-weight: 600;
}

.progress {
  /* margin-top: 6px; */
  width: 100%;
  margin: 6px 0px;
}
.progress span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 12px;
}
.progress span p {
  display: block;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #f6f6ff;
  line-height: 12px;
  border-radius: 5px;
  text-align: right;
  padding-right: 6px;
}
.tableLeft span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #3a3a3b;
}
.tableLeft b {
  font-family: "微软雅黑" !important;
  font-size: 15px;
  color: #84a05f;
}
.tableRight {
  padding: auto 4px;
  margin-top: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.tableRight .rightFlex {
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.tableRight .rightFlex span {
  min-width: 60px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
  text-align: right;
}
.tableRight .rightFlex b {
  text-align: left;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #332a66;
}

.tableLeft .leftFlex {

  display: flex;
  justify-content: left;
text-align: left;
}


.tableRight .rightFlex i {
  font-style: normal;
  text-align: left;
  min-width: 60px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
}
.tableRight .rightFlex img {
  position: absolute;
  width: 12px;
  height: 12px;
  left: 8px;
  top: -3px;
}
.box {
  margin: 1.5px auto 0;
  padding: 0 14px;
  position: relative;
}
.OneTie {
  position: relative;
  text-align: right;
  margin-left: 5px;
  width: 97%;
  height: 50px;
  background: #ffffff;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  line-height: 17px;
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #000000;
  margin-bottom: 10px;
  z-index: 999;
}
.OneTieactive {
  width: 104%;
  margin-left: -9px;
  background: #f2dec6;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  font-size: 12px;
}
.TwoTieactive {
  background: #faf1e7;
}
.TwoTieAct {
  background: #ffffff;
  margin-bottom: 8px;
  width: 96%;
  border-radius: 10px;
  margin-left: 7px;
}
.ly {
  margin-left: 10px;
  display: inline-block;
  width: 40px;
  height: 12px;
  line-height: 12px;
  text-align: center !important;
  border-radius: 6px;
  background: #d4e1b4;
}
.TwoTie {
  text-align: center;
  border-radius: 10px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;
  height: 50px;
  line-height: 17px;
  z-index: 999;
  box-shadow: 0 5px 20px -10px #704f4f;
}

.BrandThrTie,
.BrandForTie {
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;
  height: 50px;

  line-height: 17px;
  z-index: 999;
}
.channelThr {
}
</style>


// WEBPACK FOOTER //
// src/components/ButSecoend/Summary-IC/SumTable.vue